module.exports = __webpack_public_path__ + "img/m-wash2-front.a4cb776d.jpg";